import { currencyFormatter } from "@utils/formatter";

interface FreeShippingMeterProps {
    subtotal: number;
    threshold: number;
}

export const FreeShippingMeter = ({
    subtotal,
    threshold,
}: FreeShippingMeterProps) => {
    if (threshold <= 0) return null;

    const unlocked = subtotal >= threshold;
    const remaining = Math.max(0, threshold - subtotal);

    return (
        <div className="text-neutral">
            {unlocked ? (
                <p className="text-sm font-semibold text-success">
                    FREE Shipping unlocked!
                </p>
            ) : (
                <p className="text-sm">
                    Add{" "}
                    <span className="font-semibold">
                        {currencyFormatter.format(remaining)}
                    </span>{" "}
                    for FREE Shipping!
                </p>
            )}
            <progress
                className={`progress w-full mt-1 ${
                    unlocked ? "progress-success" : "progress-info"
                }`}
                value={unlocked ? threshold : subtotal}
                max={threshold}
            />
        </div>
    );
};
